import * as types from "./types";
import { concertId } from "../../../util/Params";
import Storage from "../../../api/Storage";
let userId = Storage.getUserId(concertId);
console.log("[Storage] local userId", concertId, userId);
import { key } from "../../../util/Params.js";

export const common = {
  namespaced: true,

  state: {
    page: null,
    userId: userId,
    artistKey: key,
    isTablet: false,
    needReload: false,
    loading: true,
    toFrontAPIEnable: true,
    toFrontAPIInterval: 60 * 1000,
    /**
     * 続きから描く
     */
    continueDrawing: false,
    /**
     * もう描いててリロードして戻ってきた
     */
    hasDrawn: false
  },
  getters: {},
  mutations: {
    setUserId(state, payload) {
      if (!payload.token) {
        state.userId = null;
        Storage.removeUserId(payload.concertId);
      } else {
        state.userId = payload.token;
        Storage.setUserId(payload);
      }
    },
    setContinueDrawing(state, flag) {
      state.continueDrawing = flag;
    },
    setHasDrawn(state, flag) {
      state.hasDrawn = flag;
    },
    setLoading(state, flag) {
      state.loading = flag;
    },
    setIsTablet(state, flag) {
      state.isTablet = flag;
    },
    setNeedReload(state, flag) {
      state.needReload = flag;
    },
    setPage(state, value) {
      state.page = value;
    },
    setToFrontAPI(state, flag) {
      state.toFrontAPIEnable = flag;
      setTimeout(() => {
        state.toFrontAPIEnable = true;
      }, state.toFrontAPIInterval);
    }
  },
  actions: {
    [types.SET_USER_ID]({ commit }, payload) {
      commit("setUserId", payload);
    },

    [types.SET_CONTINUE_DRAWING]({ commit }, flag) {
      commit("setContinueDrawing", flag);
    },
    [types.SET_HAS_DRAWN]({ commit }, flag) {
      commit("setHasDrawn", flag);
    },
    [types.SHOW_LOADING]({ commit }) {
      commit("setLoading", true);
    },
    [types.HIDE_LOADING]({ commit }) {
      commit("setLoading", false);
    },
    [types.SET_IS_TABLET]({ commit }, isTablet) {
      commit("setIsTablet", isTablet);
    },
    [types.SET_TO_FRONT_API_DISABLE]({ commit }) {
      commit("setToFrontAPI", false);
    },
    [types.SET_PAGE]({ commit }, value) {
      commit("setPage", value);
    },
    [types.SET_NEED_RELOAD]({ commit }, flag) {
      commit("setNeedReload", flag);
    }
  }
};
